import CheckboxInput from 'src/components/Forms/CheckboxInput';
import ChildrenInput from 'src/components/Forms/ChildrenInput';
import ChildrenSelect from 'src/components/Selects/ChildrenSelect';
import CloseButton from 'src/components/Buttons/CloseButton';
import DateFormat from 'src/utils/dateFormat';
import DatePicker from 'src/components/DatePickers/Calendar';
import FileInput from 'src/components/Forms/FileInput';
import IconButton from 'src/components/Buttons/IconButton';
import Input from 'src/components/Forms/Input';
import Modal from '../../../utils/modal';
import moment from 'src/utils/moment';
import NormalButton from '../../Buttons/NormalButton';
import React, { useCallback, useRef } from 'react';
import RichTextEditor from 'src/components/Forms/RichTextEditor';
import Select from 'src/components/Forms/Select';
import SVG from 'src/components/Images/SvgRenderer';
import Switch from 'src/components/Forms/Switch';
import TabsMenu from 'src/components/Menus/TabsMenu';
import theme from '../../../ui/theme';
import UsersInput from 'src/components/Forms/UsersInput';
import UsersSelect from 'src/components/Selects/UsersSelect';
import useStyles from './style';
import { addCalendarEvents, deleteCalendarRecurringEventsSince, editCalendarEvents, setCalendarIsLoading } from 'src/store/actions/calendar.actions';
import { base64ToArrayBuffer, classToChild, formatDate, getDayFullName, getFileType, isKey, moveLastToFirstInArray, removeDuplicatesJSON, sortObjectKeys } from 'src/utils/useFunctions';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { createNotification } from 'src/utils/createNotification';
import { getUserRole, getUserSetting } from 'src/utils/useUser';
import { isCypress } from '../../../utils/useCypress';
import { setCalendarEventHandleModal, setCalendarEventRepeatModal, setConfirmOptionsModal } from 'src/store/actions/modals.actions';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux-hooks';
import { useEffect } from 'src/utils/useEffect';
import { useStates } from 'src/utils/useState';
import { useTranslation } from 'react-i18next';
import { weekdays } from 'src/constants/weekdays';

const CalendarEventHandleModal: React.FunctionComponent = () => {

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const browserData = useAppSelector((state: any) => state.browser);
  const calendarData = useAppSelector((state: any) => state.calendar);
  const dataData = useAppSelector((state: any) => state.data);
  const languageData = useAppSelector((state: any) => state.language);
  const modalsData = useAppSelector((state: any) => state.modals);
  const userData = useAppSelector((state: any) => state.user);
  const calendarService = useAppSelector((state: any) => state.services).calendarService;
  const smallDevice = useMediaQuery(theme.breakpoints.down('md'));

  const isEdit = modalsData.calendarEventHandleModal.eventID === null ? false : true;
  const eventID = isEdit ? modalsData.calendarEventHandleModal.eventID : null;
  const recurringEventID = isEdit ? modalsData.calendarEventHandleModal.recurringEventID : null;
  const eventData = isEdit ? (calendarData.events.filter((item: any) => item.eventID === eventID).length === 1 ? calendarData.events.find((item: any) => item.eventID === eventID) : []) : [];

  const selectedDate = modalsData.calendarEventHandleModal.date;
  const selectedDateTime = modalsData.calendarEventHandleModal.dateTime;

  const modalRef: any = useRef(null);
  const headerRef: any = useRef(null);
  const footerRef: any = useRef(null);

  const getMedias = (media: any) => {
    let tempFiles: any = [];
    if(media.files) {
      media.files.forEach((file: any) => {
        const newFile = {
          ...file,
          type: 'application/pdf',
          status: "hosted",
        };
        tempFiles = [...tempFiles, newFile];
      });
    }
    if(media.photos) {
      media.photos.forEach((file: any) => {
        const newFile = {
          ...file,
          type: 'image/jpeg',
          status: "hosted",
        };
        tempFiles = [...tempFiles, newFile];
      });
    }
    if(media.videos) {
      media.videos.forEach((file: any) => {
        const newFile = {
          ...file,
          type: 'video/mp4',
          status: "hosted",
        };
        tempFiles = [...tempFiles, newFile];
      });
    }
    return tempFiles;
  };

  const userAccessSchools = userData.userAccessSchools;

  const listSchools = dataData.schools;
  const listClasses = dataData.classes;
  const listChildren = dataData.children;
  const listUsers = dataData.users;

  const availableSchools = listSchools.filter((item: any) => userAccessSchools.calendar.includes(item.schoolID) && listClasses.filter((subItem: any) => subItem.schoolID === item.schoolID).length > 0).map((item: any) => { return item; });

  const getSchoolData = useCallback((schoolID: any) => {
    return dataData.schools.filter((item: any) => item.schoolID === schoolID).length === 0 ? [] : dataData.schools.find((item: any) => item.schoolID === schoolID);
  }, [dataData.schools]);

  const getIsFullDay = () => {
    if(moment(eventData.dateTimeFrom).isSame(moment(eventData.dateTimeTo), "date")) {
      if(moment(eventData.dateTimeFrom).isSame(moment(eventData.dateTimeTo))) {
        return true;
      } else {
        return false;
      }
    } else {
      if(moment(eventData.dateTimeFrom).format("HH:mm:ss") === "00:00:00" && moment(eventData.dateTimeTo).format("HH:mm:ss") === "00:00:00") {
        return true;
      } else {
        return false;
      }
    }
  };

  const firstDayInWeek = getUserSetting(userData.userSettings, "customizations", ["calendar", "first_day_in_week"]);

  const weekdaysList: any = firstDayInWeek === 0 ? moveLastToFirstInArray(weekdays) : weekdays;

  const eventClasses = isEdit ? ((eventData && eventData.classToChild) ? removeDuplicatesJSON(eventData.classToChild.map((item: any) => { return { classID: item.classID }; })) : []) : [];
  const eventOnlyClasses = isEdit ? ((eventData && eventData.classToChild) ? removeDuplicatesJSON(eventData.classToChild.filter((item: any) => !item.childID).map((item: any) => { return { classID: item.classID }; })) : []) : [];
  const eventChildren = isEdit ? ((eventData && eventData.classToChild) ? removeDuplicatesJSON(eventData.classToChild.filter((item: any) => item.childID).map((item: any) => { return { childID: item.childID, classID: item.classID }; })) : []) : [];
  const allChildren = isEdit ? ((eventData && eventOnlyClasses) ? removeDuplicatesJSON([eventOnlyClasses.map((item: any) => { return listChildren.filter((dataItem: any) => dataItem.classID.indexOf(item.classID) !== -1).map((dataItem: any) => { return { classID: item.classID, childID: dataItem.childID }; }); }).flat(), eventChildren].flat().map((item: any) => { return { classID: item.classID, childID: item.childID }; }))  :[]) : [];

  const isCalendarEventsTypes = getUserSetting(userData.userSettings, "addons", ["calendar", "calendar_event_types"]);

  const [state, setState] = useStates({
    calendarEventType: isCalendarEventsTypes ? (isEdit ? ((eventData.userID && eventData.userID.length === 1 && eventData.userID[0] === userData.userObject.userID) ? "private" : "public") : "public") : "public",
    updateRefs: false,
    bodyHeight: null,
    modalIsFullscreen: smallDevice ? true : false,
    isFullDay: isEdit ? getIsFullDay() : (!selectedDate && !selectedDateTime) ? false : (selectedDateTime ? false : true),
    datetimeStart: isEdit ? moment(eventData.dateTimeFrom) : (!selectedDate && !selectedDateTime) ? moment().set('hour', 0).set('minute', 0).set('second', 0) : (selectedDate ? moment(selectedDate).set('hour', 0).set('minute', 0).set('second', 0) : (selectedDateTime ? moment(selectedDateTime) : moment().set('hour', 0).set('minute', 0).set('second', 0))),
    datetimeEnd: isEdit ? moment(eventData.dateTimeTo) : (!selectedDate && !selectedDateTime) ? moment().set('hour', 0).set('minute', 30).set('second', 0) : (selectedDate ? moment(selectedDate).set('hour', 0).set('minute', 0).set('second', 0) : (selectedDateTime ? moment(selectedDateTime).add(30, 'minute') : moment().set('hour', 0).set('minute', 0).set('second', 0))),
    name: isEdit ? eventData.name : "",
    description: isEdit ? eventData.description : "",
    currentSchool: isEdit ? getSchoolData(eventData.schoolID) : availableSchools[0],
    currentChildren: isEdit ? allChildren : [],
    currentUsers: isEdit ? (eventData.userID ? eventData.userID.map((item: any) => { return { userID: item, schoolID: eventData.schoolID }}) : []) : [],
    isChildrenSelectOpen: false,
    isUsersSelectOpen: false,
    media: isEdit ? (eventData.media && Object.keys(eventData.media).length > 0) ? getMedias(eventData.media) : [] : [],
    repeatOption: 'norepeat',
    repeatOptionInitial: 'norepeat',
    repeatOptionsData: {},
    repeatOptionsDataInitial: {},
    repeatMode: null,
    repeatSince: null,
    repeatTemplate: {},
    isCreatePostForChildren: false,
    isLoading: false,
    editEventID: eventID,
  });

  const repeatModeRef = useRef(state.repeatMode);
  const repeatSinceRef = useRef(state.repeatSince);
  const editEventIDRef = useRef(state.editEventID);

  const schoolID = state.currentSchool ? state.currentSchool.schoolID : availableSchools[0].schoolID;
  const availableClasses = schoolID === null ? [] : listClasses.filter((item: any) => item.schoolID === schoolID && !item.isArchived && item.active && item.childrenID.length > 0).map((item: any) => { return item; });
  const availableChildren = schoolID === null ? [] : listChildren.filter((item: any) => item.schoolsID.indexOf(schoolID) !== -1).map((item: any) => { return { childID: item.childID, classID: item.classID }; });
  const availableUsers = schoolID === null ? [] : listUsers.filter((item: any) => item.schoolsID.includes(schoolID) && (item.roleType === 2 || item.roleType === 4) && item.userID > 0).map((item: any) => { return { userID: item.userID }; });
  const refMedia = useRef(state.media);
  const allowedFiles = ["image", "attachment"];

  const isRecurringSettingsChanged = state.repeatOption !== state.repeatOptionInitial || (state.repeatOption === state.repeatOptionInitial && state.repeatOption === "customSet" && JSON.stringify(sortObjectKeys(state.repeatOptionsData)) !== JSON.stringify(sortObjectKeys(state.repeatOptionsDataInitial)));

  const classes = useStyles({
    isFullscreen: state.modalIsFullscreen,
    bodyHeight: state.bodyHeight,
  });

  const tabsItems: any = [
    {
      name: t('calendar_event_public'),
      value: 'public',
      isEnabled: true,
    },
    {
      name: t('calendar_event_private'),
      value: 'private',
      isEnabled: true,
    }
  ];

  const setCalendarEventType = (value: any) => {
    setState("calendarEventType", value);
  };

  const handleAddYourself = () => {
    const mySelf = {userID: userData.userObject.userID, schoolID: state.currentSchool.schoolID};
    const newUsers = [...state.currentUsers, mySelf];
    setState("currentUsers", newUsers);
  };

  const isDisabled = () => {
    const isPublicEvent = state.calendarEventType === "public";
    const isPrivateEvent = state.calendarEventType === "private";
    const anyUsers = state.currentUsers.length > 0;
    const onlyMe = state.currentUsers.length === 1 && state.currentUsers[0].userID === userData.userObject.userID;
    const anyChildren = state.currentChildren.length > 0;
    const validDate = state.isFullDay ? true : moment(state.datetimeStart).isBefore(moment(state.datetimeEnd)) && moment(state.datetimeEnd).isAfter(moment(state.datetimeStart));
    return isCalendarEventsTypes ? ((!isPrivateEvent && !anyUsers && !anyChildren) || !validDate || (isPublicEvent && onlyMe)) : ((!anyUsers && !anyChildren) || !validDate);
  };

  const isUserWarning = () => {
    const anyChildren = state.currentChildren.length > 0;
    const anyUsers = state.currentUsers.length > 0;
    const onlyMe = state.currentUsers.length === 1 && state.currentUsers[0].userID === userData.userObject.userID;
    const notMe = state.currentUsers.length > 0 && state.currentUsers.filter((item: any) => item.userID === userData.userObject.userID).length === 0;
    const isTeacher = getUserRole(userData.userObject.roleType) === "teacher";
    if(isCalendarEventsTypes && !anyChildren && onlyMe) {
      return (<div className={classes.warning}><SVG src="warning"/> <p>{t("calendar_event_public_only_me")} <span onClick={() => setCalendarEventType("private")}>{t('calendar_event_private')}</span>.</p></div>);
    } else if(anyUsers && !anyChildren && notMe && isTeacher) {
      return (<div className={classes.warning}><SVG src="warning"/><p>{t("calendar_event_teacher_not_selected")} <span onClick={handleAddYourself}>{t('calendar_add_yourself')}</span></p></div>);
    }
    return false;
  };
  
  const onCloseModal = () => {
    if(state.isLoading) return;
    const settings = {
      isOpen: false,
      date: null,
      dateTime: null,
      eventID: null,
      recurringEventID: null,
    };
    dispatch(setCalendarEventHandleModal(settings));
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    onCloseModal();
  };

  const handleFullscreen = () => {
    setState("modalIsFullscreen", !state.modalIsFullscreen);
  };

  const handleChangeSchool = (value: any) => {
    setState("currentSchool", value);
    setState("currentChildren", []);
    setState("currentUsers", []);
    setState("isCreatePostForChildren", false);
  };

  const handleChangeChildren = (value: any) => {
    if(value.length === 0) {
      setState("isCreatePostForChildren", false);
    }
    const newValue = value.map((item: any) => { return { childID: item.childID, classID: item.classID }; });
    setState("currentChildren", newValue);
  };

  const handleChangeUsers = (value: any) => {
    setState("currentUsers", value);
  };

  const handleDatetimeStart = (date: any) => {
    setState("datetimeStart", date);
  };

  const handleDatetimeEnd = (date: any) => {
    setState("datetimeEnd", date);
  };
  
  const handleInputChange = (name: any, value: any) => {
    setState(name, value);
  };

  const handleDescription = (value: any) => {
    setState("description", value);
  };

  const handleMedias = (value: any) => {
    setState("media", value);
    refMedia.current = value;
  };

  const handleIsFullDay = () => {
    if(!state.isFullDay) {
      setState("datetimeStart", moment(state.datetimeStart).set('hour', 0).set('minute', 0).set('second', 0));
      setState("datetimeEnd", moment(state.datetimeEnd).set('hour', 0).set('minute', 0).set('second', 0));
    } else {
      setState("datetimeStart", moment(state.datetimeStart));
      if(moment(state.datetimeStart).isSame(state.datetimeEnd)) {
        setState("datetimeEnd", moment(state.datetimeStart).add(30, 'minute'));
      } else {
        setState("datetimeEnd", moment(state.datetimeEnd));
      }
    }
    setState("isFullDay", !state.isFullDay);
  };

  const handleCreatePostForChildren = () => {
    setState("isCreatePostForChildren", !state.isCreatePostForChildren);
  };

  const handleSave = (e: any) => {
    if(!state.isFullDay) {
      if(moment(state.datetimeStart).isSameOrAfter(moment(state.datetimeEnd)) || moment(state.datetimeEnd).isSameOrBefore(moment(state.datetimeStart))) {
        createNotification(t('calendar_event_invalid_range'), "error")
        return;
      }
    }
    if(isEdit) {
      handleSelectEdit(e);
    } else {
      handleCreate(e);
    }
  };

  const handleCreate = (e: any) => {
    e.stopPropagation();
    setState("isLoading", true);
    dispatch(setCalendarIsLoading(true));
    const newMedias = state.media.filter((fileData: any) => fileData.status === "ready").map((fileData: any, key: any) => {
      return {id: key, name: fileData.name, type: getFileType(fileData.type), size: fileData.size};
    });
    const payload: any = {
      name: state.name,
      description: state.description,
      dateTimeFrom: moment(state.datetimeStart).format("YYYY-MM-DD HH:mm:ss"),
      dateTimeTo: moment(state.datetimeEnd).format("YYYY-MM-DD HH:mm:ss"),
      type: "event",
      schoolID: state.currentSchool.schoolID,
      classToChild: (isCalendarEventsTypes && state.calendarEventType === "private") ? [] : classToChild(state.currentChildren, availableChildren),
      userID: (isCalendarEventsTypes && state.calendarEventType === "private") ? [userData.userObject.userID] : (state.currentUsers.length > 0 ? state.currentUsers.map((item: any) => { return item.userID; }) : []),
      post: state.isCreatePostForChildren,
      active: state.active,
      media: newMedias,
    };
    calendarService && calendarService.createEvent(payload).then((result: any) => {
      if(result) {
        if(result.status === 201) {
          if(result.data) {
            if(result.data.eventID) {
              if(result.data.media) {
                if(result.data.media.length > 0) {
                  const uploadMedias = state.media.filter((fileData: any) => fileData.status === "ready").map((file: any, key: any) => {
                    return {...file, uploadUrl: result.data.media.find((theFile: any) => theFile.id === key).uploadUrl};  
                  })
                  handleUploadMedias(result.data.eventID, uploadMedias);
                } else {
                  if(state.repeatOption == "norepeat") {
                    handleFinish(result.data.eventID);
                  } else {
                    handleRepeat(result.data.eventID);
                  }
                }
              } else {
                setState("isLoading", false);
                dispatch(setCalendarIsLoading(false));
                createNotification(t("calendar_event_not_added"), "error");
                const updateFiles = refMedia.current.map((fileData: any) => {
                  if(fileData.status === "uploaded" || fileData.status === "uploading") {
                    return {...fileData, status: "ready"};
                  } else {
                    return fileData;
                  }
                });
                setState("media", updateFiles);
                refMedia.current = updateFiles;
              } 
            } else {
              setState("isLoading", false);
              dispatch(setCalendarIsLoading(false));
              createNotification(t("calendar_event_not_added"), "error");
              const updateFiles = refMedia.current.map((fileData: any) => {
                if(fileData.status === "uploaded" || fileData.status === "uploading") {
                  return {...fileData, status: "ready"};
                } else {
                  return fileData;
                }
              });
              setState("media", updateFiles);
              refMedia.current = updateFiles;
            }
          } else {
            setState("isLoading", false);
            dispatch(setCalendarIsLoading(false));
            createNotification(t("calendar_event_not_added"), "error");
            const updateFiles = refMedia.current.map((fileData: any) => {
              if(fileData.status === "uploaded" || fileData.status === "uploading") {
                return {...fileData, status: "ready"};
              } else {
                return fileData;
              }
            });
            setState("media", updateFiles);
            refMedia.current = updateFiles;
          }
        } else {
          setState("isLoading", false);
          dispatch(setCalendarIsLoading(false));
          createNotification(t("calendar_event_not_added"), "error");
          const updateFiles = refMedia.current.map((fileData: any) => {
            if(fileData.status === "uploaded" || fileData.status === "uploading") {
              return {...fileData, status: "ready"};
            } else {
              return fileData;
            }
          });
          setState("media", updateFiles);
          refMedia.current = updateFiles;
        }
      } else {
        setState("isLoading", false);
        dispatch(setCalendarIsLoading(false));
        createNotification(t("calendar_event_not_added"), "error");
        const updateFiles = refMedia.current.map((fileData: any) => {
          if(fileData.status === "uploaded" || fileData.status === "uploading") {
            return {...fileData, status: "ready"};
          } else {
            return fileData;
          }
        });
        setState("media", updateFiles);
        refMedia.current = updateFiles;
      }
    }).catch((e: any) => {
      createNotification(!isKey(e.response.data.message) ? e.response.data.message : t("calendar_event_not_added"), "error");
      setState("isLoading", false);
      dispatch(setCalendarIsLoading(false));
      const updateFiles = refMedia.current.map((fileData: any) => {
        if(fileData.status === "uploaded" || fileData.status === "uploading") {
          return {...fileData, status: "ready"};
        } else {
          return fileData;
        }
      });
      setState("media", updateFiles);
      refMedia.current = updateFiles;
    });
  };

  const handleSelectEdit = (e: any) => {
    if(recurringEventID) {
      const onAccept = (_: any, option: any) => {
        setState("repeatMode", option);
        repeatModeRef.current = option;
        if(option === "single_next") {
          const value = moment(state.datetimeStart);
          setState("repeatSince", value);
          repeatSinceRef.current = value;
        } else if(option === "all") {
          const value = moment(state.repeatTemplate ? state.repeatTemplate.dateTimeFrom : state.datetimeStart);
          const newEventID = state.repeatTemplate ? state.repeatTemplate.id : eventID;
          setState("repeatSince", value);
          repeatSinceRef.current = value;
          setState("editEventID", newEventID);
          editEventIDRef.current = newEventID;
        }
        handleEdit(e);
      };
      const settings = {
        isOpen: true,
        title: t('calendar_event_edit_recurring'),
        options: [
          !isRecurringSettingsChanged ? {
            name: t('calendar_event_single'),
            value: 'single',
            dataCy: 'singleEventRadio',
          } : null,
          {
            name: t('calendar_event_single_next'),
            value: 'single_next',
            dataCy: 'singleNextEventRadio',
          },
          {
            name: t('calendar_event_all'),
            value: 'all',
            dataCy: 'allEventsRadio',
          },
        ],
        onAccept: onAccept,
        onDecline: null,
      };
      dispatch(setConfirmOptionsModal(settings));
    } else {
      handleEdit(e);
    }
  };

  const handleEdit = (e: any) => {
    e.stopPropagation();
    setState("isLoading", true);
    dispatch(setCalendarIsLoading(true));
    const newMedias = state.media.filter((fileData: any) => fileData.status === "ready").map((fileData: any, key: any) => {
      return {id: key, name: fileData.name, type: getFileType(fileData.type), size: fileData.size};
    });
    const deletedMedias = state.media.filter((fileData: any) => fileData.status === "deleted").map((fileData: any) => {
      return fileData.mediaID;
    });
    const payload: any = {
      name: state.name,
      description: state.description,
      dateTimeFrom: moment(repeatModeRef.current === "all" ? state.repeatTemplate.dateTimeFrom : state.datetimeStart).format("YYYY-MM-DD HH:mm:ss"),
      dateTimeTo: moment(repeatModeRef.current === "all" ? state.repeatTemplate.dateTimeTo : state.datetimeEnd).format("YYYY-MM-DD HH:mm:ss"),
      type: "event",
      schoolID: state.currentSchool.schoolID,
      classToChild: (isCalendarEventsTypes && state.calendarEventType === "private") ? [] : classToChild(state.currentChildren, availableChildren),
      userID: (isCalendarEventsTypes && state.calendarEventType === "private") ? [userData.userObject.userID] : (state.currentUsers.length > 0 ? state.currentUsers.map((item: any) => { return item.userID; }) : []),
      active: state.active,
      media: newMedias,
      deletedMediasID: deletedMedias,
    };
    calendarService && calendarService.editEvent(editEventIDRef.current, payload).then((result: any) => {
      if(result) {
        if(result.status === 201) {
          if(result.data) {
            if(result.data.eventID) {
              if(result.data.media) {
                if(result.data.media.length > 0) {
                  const uploadMedias = state.media.filter((fileData: any) => fileData.status === "ready").map((file: any, key: any) => {
                    return {...file, uploadUrl: result.data.media.find((theFile: any) => theFile.id === key).uploadUrl};  
                  });
                  handleUploadMedias(editEventIDRef.current, uploadMedias);
                } else {
                  if(repeatModeRef.current === "single" || !recurringEventID) {
                    handleFinish(editEventIDRef.current);
                  } else {
                    handleRepeat(editEventIDRef.current);
                  }
                }
              } else {
                setState("isLoading", false);
                dispatch(setCalendarIsLoading(false));
                createNotification(t("calendar_event_not_updated"), "error");
                const updateFiles = refMedia.current.map((fileData: any) => {
                  if(fileData.status === "uploaded" || fileData.status === "uploading") {
                    return {...fileData, status: "ready"};
                  } else {
                    return fileData;
                  }
                });
                setState("media", updateFiles);
                refMedia.current = updateFiles;
              }
            } else {
              setState("isLoading", false);
              dispatch(setCalendarIsLoading(false));
              createNotification(t("calendar_event_not_updated"), "error");
              const updateFiles = refMedia.current.map((fileData: any) => {
                if(fileData.status === "uploaded" || fileData.status === "uploading") {
                  return {...fileData, status: "ready"};
                } else {
                  return fileData;
                }
              });
              setState("media", updateFiles);
              refMedia.current = updateFiles;
            }
          } else {
            setState("isLoading", false);
            dispatch(setCalendarIsLoading(false));
            createNotification(t("calendar_event_not_updated"), "error");
            const updateFiles = refMedia.current.map((fileData: any) => {
              if(fileData.status === "uploaded" || fileData.status === "uploading") {
                return {...fileData, status: "ready"};
              } else {
                return fileData;
              }
            });
            setState("media", updateFiles);
            refMedia.current = updateFiles;
          }
        } else {
          setState("isLoading", false);
          dispatch(setCalendarIsLoading(false));
          createNotification(t("calendar_event_not_updated"), "error");
          const updateFiles = refMedia.current.map((fileData: any) => {
            if(fileData.status === "uploaded" || fileData.status === "uploading") {
              return {...fileData, status: "ready"};
            } else {
              return fileData;
            }
          });
          setState("media", updateFiles);
          refMedia.current = updateFiles;
        }
      } else {
        setState("isLoading", false);
        dispatch(setCalendarIsLoading(false));
        createNotification(t("calendar_event_not_updated"), "error");
        const updateFiles = refMedia.current.map((fileData: any) => {
          if(fileData.status === "uploaded" || fileData.status === "uploading") {
            return {...fileData, status: "ready"};
          } else {
            return fileData;
          }
        });
        setState("media", updateFiles);
        refMedia.current = updateFiles;
      }
    }).catch((e: any) => {
      createNotification(!isKey(e.response.data.message) ? e.response.data.message : t("calendar_event_not_updated"), "error");
      setState("isLoading", false);
      dispatch(setCalendarIsLoading(false));
      const updateFiles = refMedia.current.map((fileData: any) => {
        if(fileData.status === "uploaded" || fileData.status === "uploading") {
          return {...fileData, status: "ready"};
        } else {
          return fileData;
        }
      });
      setState("media", updateFiles);
      refMedia.current = updateFiles;
    });
  };

  const handleUploadMedias = (newEventID: any, sentFiles: any) => {
    const file = sentFiles[0];
    const newFiles = sentFiles.filter((fileData: any) => fileData.uid !== file.uid);
    const updateFiles = refMedia.current.map((fileData: any) => {
      if(fileData.uid === file.uid) {
        return {...fileData, status: "uploading"};
      } else {
        return fileData;
      }
    });
    setState("media", updateFiles);
    refMedia.current = updateFiles;
    const reader = new FileReader();
    reader.onload = function() {
      const dataUrl: any = reader.result;
      const base64 = dataUrl.split(',')[1];
      const arrayBuffer = base64ToArrayBuffer(base64);
      calendarService && calendarService.uploadFile(file.uploadUrl, arrayBuffer).then((result: any) => {
        if(result) {
          if(result.status === 201) {
            const updateFiles = refMedia.current.map((fileData: any) => {
              if(fileData.uid === file.uid) {
                return {...fileData, status: "uploaded"};
              } else {
                return fileData;
              }
            });
            setState("media", updateFiles);
            refMedia.current = updateFiles;
            if(newFiles.length === 0) {
              if(state.repeatOption == "norepeat") {
                handleFinish(newEventID);
              } else {
                handleRepeat(newEventID);
              }
            } else {
              handleUploadMedias(newEventID, newFiles);  
            }
          } else {
            setState("isLoading", false);
            dispatch(setCalendarIsLoading(false));
            createNotification(isEdit ? t("calendar_event_not_updated") : t("calendar_event_not_added"), "error");
            const updateFiles = refMedia.current.map((fileData: any) => {
              if(fileData.status === "uploaded" || fileData.status === "uploading") {
                return {...fileData, status: "ready"};
              } else {
                return fileData;
              }
            });
            setState("media", updateFiles);
            refMedia.current = updateFiles;
          }
        } else {
          setState("isLoading", false);
          dispatch(setCalendarIsLoading(false));
          createNotification(isEdit ? t("calendar_event_not_updated") : t("calendar_event_not_added"), "error");
          const updateFiles = refMedia.current.map((fileData: any) => {
            if(fileData.status === "uploaded" || fileData.status === "uploading") {
              return {...fileData, status: "ready"};
            } else {
              return fileData;
            }
          });
          setState("media", updateFiles);
          refMedia.current = updateFiles;
        }
      }).catch((e: any) => {
        createNotification(!isKey(e.response.data.message) ? e.response.data.message : (isEdit ? t('calendar_event_not_updated') : t("calendar_event_not_added")), "error");
      });
    };
    reader.readAsDataURL(file.blob);
  };
  const handleRepeat = (eventID: any) => {
    let payload: any = {
      templateCalendarEventID: eventID,
    };
    if(isRecurringSettingsChanged || !isEdit) {
      if(state.repeatOption === "norepeat") {
        payload = {
          ...payload,
          deleted: true,
        };
      } else if(state.repeatOption === "daily") {
        payload = {
          ...payload,
          frequency: "daily",
          interval: 1,
          count: 365,
        };
      } else if(state.repeatOption === "weekly") {
        payload = {
          ...payload,
          frequency: "weekly",
          interval: 1,
          count: 52,
        };
      } else if(state.repeatOption === "monthly") {
        payload = {
          ...payload,
          frequency: "monthly",
          interval: 1,
          count: 12,
        };
      } else if(state.repeatOption === "workdays") {
        payload = {
          ...payload,
          frequency: "custom",
          interval: 1,
          count: 52,
          daysOfWeek: [1, 2, 3, 4, 5],
        };
      } else if(state.repeatOption === "weekdays") {
        payload = {
          ...payload,
          frequency: "custom",
          interval: 1,
          count: 52,
          daysOfWeek: [0, 6],
        };
      } else if(state.repeatOption === "customSet") {
        const options = state.repeatOptionsData;
        if(options.repeatFrequency === "day") {
          payload = {
            ...payload,
            frequency: "daily",
            interval: options.repeatFrequencyCount,
          };
        } else if(options.repeatFrequency === "week") {
          const weekdays = options.repeatDays;
          payload = {
            ...payload,
            frequency: "custom",
            interval: options.repeatFrequencyCount,
            daysOfWeek: weekdays,
          };
        } else if(options.repeatFrequency === "month") {
          payload = {
            ...payload,
            frequency: "monthly",
            interval: options.repeatFrequencyCount,
          };
        }
        if(options.repeatEnd === "never") {
          if(options.repeatFrequency === "day") {
            payload = {
              ...payload,
              count: 365,
            };
          } else if(options.repeatFrequency === "week") {
            payload = {
              ...payload,
              count: 52,
            };
          } else if(options.repeatFrequency === "month") {
            payload = {
              ...payload,
              count: 12,
            };
          }
        } else if(options.repeatEnd === "atDay") {
          payload = {
            ...payload,
            until: moment(options.repeatEndDate).format("YYYY-MM-DD HH:mm:ss"),
          };
        } else if(options.repeatEnd === "after") {
          payload = {
            ...payload,
            count: options.repeatEndCount,
          };
        }
      }
    }
    if(isEdit && recurringEventID) {
      payload = {
        ...payload,
        sinceWhenApplyDt: moment(repeatSinceRef.current).subtract(1, "second").format("YYYY-MM-DD HH:mm:ss"),
      };
      calendarService && calendarService.editEventRecurring(recurringEventID, payload).then((result: any) => {
        if(result) {
          if(result.status === 200) {
            if(result.data) {
              const settings = {
                recurringEventID: recurringEventID,
                since: moment(repeatSinceRef.current).subtract(1, "second").format("YYYY-MM-DD HH:mm:ss"),
              };
              dispatch(deleteCalendarRecurringEventsSince(settings));
              const events = result.data.calendarEvents;
              const eventsID = events.map((item: any) => { return item.id; }).join(",");
              const payload = {
                eventID: eventsID,
                dateFrom: moment(repeatModeRef.current === "all" ? state.repeatTemplate.dateTimeFrom : state.datetimeStart).format("YYYY-MM-DD"),
                dateTo: moment(repeatModeRef.current === "all" ? state.repeatTemplate.dateTimeTo : state.datetimeEnd).add(1, "year").format("YYYY-MM-DD")
              };
              calendarService && calendarService.listCalendar(payload).then((result: any) => {
                if(result) {
                  if(result.data) {
                    if(result.data.events) {
                      dispatch(addCalendarEvents(result.data.events));
                      handleFinish(eventID);
                    } else {
                      createNotification(t("calendar_event_recurring_not_load"), "error");
                      handleFinish(eventID);
                    }
                  } else {
                    createNotification(t("calendar_event_recurring_not_load"), "error");
                    handleFinish(eventID);
                  }
                } else {
                  createNotification(t("calendar_event_recurring_not_load"), "error");
                  handleFinish(eventID);
                }
              }).catch((e: any) => {
                createNotification(!isKey(e.response.data.message) ? e.response.data.message : t("calendar_event_recurring_not_load"), "error");
              });
            } else {
              createNotification(t("calendar_event_recurring_not_added"), "error");
              handleFinish(eventID);
            }
          } else {
            createNotification(t("calendar_event_recurring_not_added"), "error");
            handleFinish(eventID);
          }
        } else {
          createNotification(t("calendar_event_recurring_not_added"), "error");
          handleFinish(eventID);
        }
      }).catch((e: any) => {
        createNotification(!isKey(e.response.data.message) ? e.response.data.message : (isEdit ? t('calendar_event_recurring_not_updated') : t("calendar_event_recurring_not_added")), "error");
        handleFinish(eventID);
      });
    } else {
      calendarService && calendarService.createEventRecurring(payload).then((result: any) => {
        if(result) {
          if(result.status === 201) {
            if(result.data) {
              const events = result.data.calendarEvents;
              const eventsID = events.map((item: any) => { return item.id; }).join(",");
              const payload = {
                eventID: eventsID,
                dateFrom: moment(state.datetimeStart).format("YYYY-MM-DD"),
                dateTo: moment(state.dateTimeEnd).add(1, "year").format("YYYY-MM-DD")
              };
              calendarService && calendarService.listCalendar(payload).then((result: any) => {
                if(result) {
                  if(result.data) {
                    if(result.data.events) {
                      dispatch(addCalendarEvents(result.data.events));
                      handleFinish(eventID);
                    } else {
                      createNotification(t("calendar_event_recurring_not_load"), "error");
                      handleFinish(eventID);
                    }
                  } else {
                    createNotification(t("calendar_event_recurring_not_load"), "error");
                    handleFinish(eventID);
                  }
                } else {
                  createNotification(t("calendar_event_recurring_not_load"), "error");
                  handleFinish(eventID);
                }
              }).catch((e: any) => {
                createNotification(!isKey(e.response.data.message) ? e.response.data.message : t("calendar_event_recurring_not_load"), "error");
              });
            } else {
              createNotification(t("calendar_event_recurring_not_added"), "error");
              handleFinish(eventID);
            }
          } else {
            createNotification(t("calendar_event_recurring_not_added"), "error");
            handleFinish(eventID);
          }
        } else {
          createNotification(t("calendar_event_recurring_not_added"), "error");
          handleFinish(eventID);
        }
      }).catch((e: any) => {
        createNotification(!isKey(e.response.data.message) ? e.response.data.message : (isEdit ? t('calendar_event_recurring_not_updated') : t("calendar_event_recurring_not_added")), "error");
        handleFinish(eventID);
      });
    }
  };

  const handleFinish = (eventID: any) => {
    const payload = {
      eventID: eventID,
      dateFrom: moment(state.datetimeStart).format("YYYY-MM-DD"),
      dateTo: moment(state.datetimeEnd).add(1, "year").format("YYYY-MM-DD")
    };
    calendarService && calendarService.listCalendar(payload).then((result: any) => {
      if(result) {
        if(result.data) {
          if(result.data.events) {
            if(isEdit) {
              createNotification(t("calendar_event_updated"), "success");
              dispatch(editCalendarEvents(result.data.events));
            } else {
              createNotification(t("calendar_event_added"), "success");
              dispatch(addCalendarEvents(result.data.events));
            }
            onCloseModal();
            dispatch(setCalendarIsLoading(false));
          } else {
            setState("isLoading", false);
            dispatch(setCalendarIsLoading(false));
            createNotification(isEdit ? t("calendar_event_not_updated") : t("calendar_event_not_added"), "error");
            const updateFiles = refMedia.current.map((fileData: any) => {
              if(fileData.status === "uploaded" || fileData.status === "uploading") {
                return {...fileData, status: "ready"};
              } else {
                return fileData;
              }
            });
            setState("media", updateFiles);
            refMedia.current = updateFiles;
          }
        } else {
            setState("isLoading", false);
            dispatch(setCalendarIsLoading(false));
            createNotification(isEdit ? t("calendar_event_not_updated") : t("calendar_event_not_added"), "error");
            const updateFiles = refMedia.current.map((fileData: any) => {
              if(fileData.status === "uploaded" || fileData.status === "uploading") {
                return {...fileData, status: "ready"};
              } else {
                return fileData;
              }
            });
            setState("media", updateFiles);
            refMedia.current = updateFiles;
          }
        } else {
          setState("isLoading", false);
          dispatch(setCalendarIsLoading(false));
          createNotification(isEdit ? t("calendar_event_not_updated") : t("calendar_event_not_added"), "error");
          const updateFiles = refMedia.current.map((fileData: any) => {
            if(fileData.status === "uploaded" || fileData.status === "uploading") {
              return {...fileData, status: "ready"};
            } else {
              return fileData;
            }
          });
          setState("media", updateFiles);
          refMedia.current = updateFiles;
        }
    });
  }; 

  useEffect(() => {
    if(modalRef.current && headerRef.current && footerRef.current) {
      const modalHeight = state.modalIsFullscreen ? browserData.height : modalRef.current.clientHeight;   
      const headerHeight = headerRef.current.clientHeight; 
      const footerHeight = footerRef.current.clientHeight; 
      const bodyHeight = modalHeight - headerHeight - footerHeight; 
      setState("bodyHeight", bodyHeight);
    } else {
      if(!state.updateRefs) {
        setState("updateRefs", true);
      }
    }
    if(state.updateRefs) {
      setState("updateRefs", false);
    }
  }, [state.modalIsFullscreen, browserData.height, state.updateRefs, setState], [state.modalIsFullscreen, browserData.height, state.updateRefs]);

  useEffect(() => {
    setState("modalIsFullscreen", smallDevice ? true : false);
  }, [browserData.height, smallDevice, setState], [browserData.height]);

  const getRepeatTitle = () => {
    const data = state.repeatOptionsData;
    const weekdaysRepeat = (data.repeatFrequency === "week" && data.repeatDays && Array.isArray(data.repeatDays)) ? ` ${t('calendar_repeat_at_day_short').toLowerCase()} ${data.repeatDays.map((item: any) => { return t(getDayFullName(weekdaysList, item).toLowerCase()).toLowerCase(); }).join(", ")}` : "";
    const repeatEnd = data.repeatEnd === "never" ? t('calendar_repeat_never_short').toLowerCase() : (data.repeatEnd === "atDay" ? `${t('calendar_repeat_to_day_short').toLowerCase()} ${DateFormat(moment(data.repeatEndDate), "default", languageData, t)}` : (data.repeatEnd === "after" ? `${data.repeatEndCount}${t('calendar_repeat_end_count').toLowerCase()}` : ""));
    const text = `${t(data.repeatFrequencyCount < 5 ? t('calendar_repeat_every_short') : t('calendar_repeat_every_more_short'))} ${data.repeatFrequencyCount} ${formatDate(data.repeatFrequencyCount, data.repeatFrequency, t)}${weekdaysRepeat}, ${repeatEnd}`;
    return text;
  };

  const calendarRepeatOptions = [
    {
      name: t('calendar_repeat_no_repeat'),
      value: 'norepeat',
    },
    {
      name: t('calendar_repeat_daily'),
      value: 'daily',
    },
    {
      name: t('calendar_repeat_weekly'),
      value: 'weekly',
    },
    {
      name: t('calendar_repeat_monthly'),
      value: 'monthly',
    },
    {
      name: t('calendar_repeat_workdays'),
      value: 'workdays',
    },
    {
      name: t('calendar_repeat_weekdays'),
      value: 'weekdays',
    },
    Object.keys(state.repeatOptionsData).length > 0 ? {
      name: getRepeatTitle(),
      value: "customSet",
      disabled: true,
    } : null,
    {
      name: t('calendar_repeat_custom'),
      value: 'custom',
    },
  ].filter((item: any) => item !== null);

  const getRepeatValue = (value: any) => {
    if(value) {
      const isExist = calendarRepeatOptions.filter((item: any) => item.value === value).length === 1;
      if(isExist) {
        return calendarRepeatOptions.find((item: any) => item.value === value);
      } else {
        return calendarRepeatOptions[0];
      }
    } else {
      return calendarRepeatOptions[0];
    }
  };

  const handleChangeRepeat = (value: any) => {
    const val = value.value;
    if(val !== "custom") {
      setState("repeatOption", val);
      setState("repeatOptionsData", {});
    } else {
      const onSave = (value: any) => {
        if(value.repeatEnd === "never") {
          if(value.repeatFrequency === "day" && value.repeatFrequencyCount === 1) {
            setState("repeatOption", "daily");
            setState("repeatOptionsData", {});
          } else if(value.repeatFrequency === "week" && value.repeatFrequencyCount === 1 && value.repeatDays.length === 0) {
            setState("repeatOption", "weekly");
            setState("repeatOptionsData", {});
          } else if(value.repeatFrequency === "month" && value.repeatFrequencyCount === 1) {
            setState("repeatOption", "monthly");
            setState("repeatOptionsData", {});
          } else {
            setState("repeatOption", "customSet");
            setState("repeatOptionsData", sortObjectKeys(value));
          }
        } else {
          setState("repeatOption", "customSet");
          setState("repeatOptionsData", sortObjectKeys(value));
        }
      };
      const settings = {
        isOpen: true,
        options: state.repeatOptionsData,
        date: state.datetimeStart,
        onSave: onSave,
      };
      dispatch(setCalendarEventRepeatModal(settings));
    }
  };

  const loadRecurringData = useCallback(() => {
    setState("isLoading", true);
    calendarService && calendarService.getEventRecurring(recurringEventID).then((result: any) => {
      if(result) {
        if(result.data) {
          const data = result.data;
          let options: any = {};
          if(data.frequency && data.interval) {
            if(data.frequency === "daily") {
              options = {
                ...options,
                repeatFrequency: "day",
                repeatFrequencyCount: data.interval,
              };
            } else if(data.frequency === "weekly") {
              options = {
                ...options,
                repeatFrequency: "week",
                repeatFrequencyCount: data.interval,
              };
            } else if(data.frequency === "monthly") {
              options = {
                ...options,
                repeatFrequency: "month",
                repeatFrequencyCount: data.interval,
              };
            } else if(data.frequency === "custom") {
              const days = data.daysOfWeek.map((item: any) => { return parseInt(item); });
              options = {
                ...options,
                repeatDays: days,
                repeatFrequency: "week",
                repeatFrequencyCount: data.interval,
              };
            }
          }
          if(data.until) {
            options = {
              ...options,
              repeatEnd: "atDay",
              repeatEndDate: moment(data.until),
            };
          }
          if(data.count) {
            if(data.frequency === "daily" && data.count === 365) {
              options = {
                ...options,
                repeatEnd: "never",
              };
            } else if(data.frequency === "weekly" && data.count === 52 && data.daysOfWeek.length === 0) {
              options = {
                ...options,
                repeatEnd: "never",
              };
            } else if(data.frequency === "monthly" && data.count === 12) {
              options = {
                ...options,
                repeatEnd: "never",
              };
            } else {
              options = {
                ...options,
                repeatEnd: "after",
              };
            }
            options = {
              ...options,
              repeatEndCount: data.count,
            };
          }
          if(options.repeatFrequency && options.repeatFrequency === "day" && options.repeatFrequencyCount && options.repeatFrequencyCount === 1 && options.repeatEnd && options.repeatEnd === "never") {
            setState("repeatOption", "daily");
            setState("repeatOptionsData", {});
            setState("repeatOptionInitial", "daily");
            setState("repeatOptionsDataInitial", {});
          } else if(options.repeatFrequency && options.repeatFrequency === "week" && options.repeatFrequencyCount && options.repeatFrequencyCount === 1 && options.repeatEnd && options.repeatEnd === "never") {
            setState("repeatOption", "weekly");
            setState("repeatOptionsData", {});
            setState("repeatOptionInitial", "weekly");
            setState("repeatOptionsDataInitial", {});
          } else if(options.repeatFrequency && options.repeatFrequency === "month" && options.repeatFrequencyCount && options.repeatFrequencyCount === 1 && options.repeatEnd && options.repeatEnd === "never") {
            setState("repeatOption", "monthly");
            setState("repeatOptionsData", {});
            setState("repeatOptionInitial", "monthly");
            setState("repeatOptionsDataInitial", {});
          } else {
            setState("repeatOption", "customSet");
            setState("repeatOptionsData", sortObjectKeys(options));
            setState("repeatOptionInitial", "customSet");
            setState("repeatOptionsDataInitial", sortObjectKeys(options));
          }
          setState("repeatTemplate", data.templateCalendarEvent);
          setState("isLoading", false);
        }
      }
    });
  }, []);

  useEffect(() => {
    if(recurringEventID !== null) {
      loadRecurringData();
    }
  }, [], []);

  return (
    <Modal 
      open={true}
      onClose={onCloseModal}
      disableEscapeKeyDown={true}
      isFullscreen={state.modalIsFullscreen}
    >
      <div className={classes.root} data-cy={isCypress() ? "calendarEventHandleModal" : null} ref={modalRef}>
        <div className={classes.header} ref={headerRef}>
          <div className={classes.headerInnerWrapper}>
            <div className={classes.wrapper}>
              <p>{isEdit ? t('calendar_edit_event') : t('calendar_add_event')}</p>
            </div>
            <div className={classes.buttons}>
              {
                !smallDevice ? (
                  <IconButton className={classes.button} onClick={handleFullscreen} data-cy={isCypress() ? "fullscreenButton" : null} tooltip={state.modalIsFullscreen ? t('mode_window') : t('mode_fullscreen')} tooltipPosition='bottom' disabled={state.isLoading}>
                    {state.modalIsFullscreen ? (<SVG src="fullscreen-exit"/>) : (<SVG src="fullscreen-enter"/>)}
                  </IconButton>
                ) : null
              }
              <CloseButton onClick={handleClose} dataCy="timesButton" disabled={state.isLoading}/> 
            </div>
          </div>
          {
            isCalendarEventsTypes ? (
              <TabsMenu className={classes.tabs} items={tabsItems} selected={state.calendarEventType} onSelect={setCalendarEventType}/>
            ) : null
          }
        </div>
        <div className={classes.body}>
          <div className={classes.bodyWrapper}>
            <div className={classes.item}>
              <span className={classes.title}>
                <SVG src="pencil"/>
                {t('calendar_event_name')}
              </span>
              <Input placeholder={t('calendar_event_name')} name="name" value={state.name} onChange={handleInputChange} disabled={state.isLoading} autoFocus={true}/>
            </div>
            <div className={classes.item}>
              <span className={classes.title}>
                <SVG src="calendar"/>
                {t('date')}
              </span>
              <div className={classes.items}>
                <div className={classes.datepickers}>
                  {
                    state.isFullDay ? (
                      <>
                        <DatePicker presetDate={state.datetimeStart} presetDateRange={{start: state.datetimeStart, end: state.datetimeEnd}} time={false} start setDate={handleDatetimeStart} disabled={state.isLoading}/>
                        -
                        <DatePicker presetDate={state.datetimeEnd} presetDateRange={{start: state.datetimeStart, end: state.datetimeEnd}} time={false} end setDate={handleDatetimeEnd} disabled={state.isLoading}/>
                      </>
                    ) : (
                      <>
                        <DatePicker presetDate={state.datetimeStart} presetDateRange={{start: state.datetimeStart, end: state.datetimeEnd}} time={true} start setDate={handleDatetimeStart} disabled={state.isLoading}/>
                        -
                        <DatePicker presetDate={state.datetimeEnd} presetDateRange={{start: state.datetimeStart, end: state.datetimeEnd}} time={true} end setDate={handleDatetimeEnd} disabled={state.isLoading}/>
                      </>
                    )
                  }
                </div>
                <div className={classes.dateSettings}>
                  <Switch checked={state.isFullDay} onChange={handleIsFullDay} label={t('calendar_event_whole_day')} disabled={state.isLoading}/>
                  {
                    ((moment(state.datetimeStart).isSameOrAfter(moment(state.datetimeEnd)) || moment(state.datetimeEnd).isSameOrBefore(moment(state.datetimeStart))) && !state.isFullDay) ? (
                      <span className={classes.error}>
                        <SVG src="exclamation-mark-circle-outlined"/>
                        {t('calendar_invalid_timerange')}
                      </span>
                    ) : null
                  }
                </div>
                <Select className={classes.autoSelect} inputLabel={t("school")} items={calendarRepeatOptions} selected={state.repeatOption ? getRepeatValue(state.repeatOption) : calendarRepeatOptions[0]} setSelected={handleChangeRepeat} width={200} allowClear={false} disabled={state.isLoading}/>
              </div>
            </div>
            <div className={classes.item}>
              <span className={classes.title}>
                <SVG src="info-circle-outlined"/>
                {t('calendar_event_description')}
              </span>
              <RichTextEditor uid="calendarEventContent" value={state.description} onChange={handleDescription} disabled={state.isLoading}/>
            </div>
            {
              (!isCalendarEventsTypes || state.calendarEventType === "public") ? (
                <>
                  <div className={classes.item}>
                    <span className={classes.title}>
                      <SVG src="school"/>
                      {t('school')}
                    </span>
                    <Select className={classes.select} inputLabel={t("school")} items={availableSchools} selected={state.currentSchool ? state.currentSchool : availableSchools[0]} setSelected={handleChangeSchool} width={200} allowClear={false} disabled={state.isLoading || availableSchools.length === 1}/>
                  </div>           
                  <div className={classes.item}>
                    <span className={classes.title}>
                      <SVG src="people"/>
                      {t('children')}
                    </span>
                    <ChildrenInput selectLabel={t('children')} showSelectLabelIcon={false} classNameWrapper={classes.select} selectedChildren={state.currentChildren.length > 0 ? state.currentChildren : []} setSelectedChildren={handleChangeChildren} isDeletable={false} onClick={() => setState("isChildrenSelectOpen", true)} disabled={state.isLoading} maxRows={3}/>
                    {
                      state.isChildrenSelectOpen ? (
                        <ChildrenSelect
                          selectedChildren={state.currentChildren.map((item: any) => { return { childID: item.childID, classID: item.classID }; })}
                          customSort={eventClasses.map((item: any, key: any) => { return { classID: item.classID, customSortOrder: key }; })}
                          isInModal={true}
                          isModalOpen={true}
                          defaultClasses={availableClasses}
                          defaultChildren={availableChildren}
                          modalTitle="children"
                          mode="select"
                          modalAllowCancel={false}
                          modalAllowClose={true}
                          modalAllowClear={true}
                          modalAllowNoChild={true}
                          isSelectAll={true}
                          isSelectInAllClass={false}
                          isMultipleSelect={true}
                          isAllowArchived={false}
                          isAllowInactiveClasses={false}
                          isAllowArchivedToggle={false}
                          modalOnClose={() => setState("isChildrenSelectOpen", false)}
                          modalOnSave={handleChangeChildren}
                          modalAllowChildrenCount={true}
                        />
                      ) : null
                    }
                  </div>
                  <div className={classes.item}>
                    <span className={classes.title}>
                      <SVG src="people"/>
                      {t('teachers')}
                    </span>
                    <div className={classes.info}>
                      <UsersInput selectLabel={t('teachers')} showSelectLabelIcon={false} classNameWrapper={classes.select} selectedUsers={state.currentUsers} setSelectedUsers={handleChangeUsers} isDeletable={false} onClick={() => setState("isUsersSelectOpen", true)} disabled={state.isLoading} maxRows={3}/>
                      {
                        state.isUsersSelectOpen ? (
                          <UsersSelect
                            selectedUsers={state.currentUsers}
                            isInModal={true}
                            isModalOpen={true}
                            defaultSchools={[{schoolID: schoolID}]}
                            defaultUsers={availableUsers}
                            isAllowArchived={false}
                            modalTitle="teachers"
                            mode="select"
                            modalAllowClose={true}
                            modalAllowClear={true}
                            modalAllowCancel={false}
                            modalAllowNoUser={true}
                            isSelectAll={true}
                            isMultipleSelect={true}
                            modalOnClose={() => setState("isUsersSelectOpen", false)}
                            modalOnSave={handleChangeUsers}
                            modalAllowUsersCount={true}
                          />
                        ) : null
                      }
                      {
                        isUserWarning()
                      }
                    </div>
                  </div>
                </>
              ) : null
            }
            <div className={classes.item}>
              <span className={classes.title}>
                <SVG src="attachment"/>
                {t('attachments')}
              </span>
              <FileInput files={state.media} onChange={handleMedias} allowed={allowedFiles} disabled={state.isLoading} mediaLimit='calendar'/>
            </div>
            {
              !isEdit ? (
                <>
                  {
                    (!isCalendarEventsTypes || state.calendarEventType === "public") ? (
                      <div className={classes.item}>
                        <span className={classes.title}/>
                        <CheckboxInput className={classes.checkbox} label={t('calendar_create_post_for_children')} checked={state.isCreatePostForChildren} onChange={handleCreatePostForChildren} disabled={state.isLoading || state.currentChildren.length === 0}/>
                      </div>
                    ) : null
                  }
                </>
              ) : null
            }   
          </div>
        </div>
        {
          state.isLoading ? (
            <div className={classes.loadingWrapper}>
              <div className={classes.spinner}>
                <CircularProgress/>
              </div>
            </div>
          ) : null
        }
        <div className={classes.footer} ref={footerRef}>
          <NormalButton buttonType="secondary" onClick={handleClose} dataCy="cancelButton" disabled={state.isLoading}>
            {t("cancel")}
          </NormalButton>
          <NormalButton buttonType="primary" onClick={handleSave} dataCy="saveButton" disabled={state.isLoading || state.name === "" || isDisabled()}>
            {state.isLoading ? t('saving') : (isEdit ? t("save") : t("create"))}
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
};

export default CalendarEventHandleModal;